module.exports = __webpack_public_path__ + "static/img/img.0d37fb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/6/img.png
// module id = sY+q
// module chunks = 0